import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapsible, Dropdown, getTestId, Input, isValidObject, StateConfigContext } from '@airtel/air-design-system';
import { debounce, merge } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Keyboard, View } from 'react-native';
import { LinkListItemWidget } from '../../../link-list-item-widget';
import { getSkycFormWidgetStyles } from '../../SkycFormWidgetStyles';
import { simPortDetailsConfig, successAvatarConfig } from './SimPortDetailsConfig';
import { getSimPortDetailsStyles } from './SimPortDetailsStyles';
import { getIsDisabledState, getSubHeading, validateInputField } from './SimPortDetailsUtils';
export var SimPortDetails = props => {
  var _a;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useMemo = useMemo(() => merge({}, simPortDetailsConfig, props), [simPortDetailsConfig, props]),
    _state = _useMemo.state,
    successStateHeading = _useMemo.successStateHeading,
    isExpanded = _useMemo.isExpanded,
    disableToggle = _useMemo.disableToggle,
    testID = _useMemo.testID,
    variant = _useMemo.variant,
    autoFormSubmitDebounceDelay = _useMemo.autoFormSubmitDebounceDelay,
    isAutoFormSubmitDebounceAllowed = _useMemo.isAutoFormSubmitDebounceAllowed,
    style = _useMemo.style,
    onUserAction = _useMemo.onUserAction,
    id = _useMemo.id,
    _stepDetails = _useMemo.stepDetailsProps,
    onStepDetailsListItemPressMetaData = _useMemo.onStepDetailsListItemPressMetaData,
    onStepDetailsCtaPressMetaData = _useMemo.onStepDetailsCtaPressMetaData,
    _inputData = _useMemo.inputsDataProps,
    onValidFormMetaData = _useMemo.onValidFormMetaData,
    onInValidFormMetaData = _useMemo.onInValidFormMetaData,
    dropdownsDataProps = _useMemo.dropdownsDataProps;
  var _useState = useState(_inputData === null || _inputData === void 0 ? void 0 : _inputData.mobileNumber),
    mobileNumberInputProps = _useState[0],
    setMobileNumberInputProps = _useState[1];
  var _useState2 = useState(_inputData === null || _inputData === void 0 ? void 0 : _inputData.upcCode),
    upcCodeInputProps = _useState2[0],
    setUpcCodeInputProps = _useState2[1];
  var simProvider = dropdownsDataProps.simProvider;
  var _useState3 = useState((simProvider === null || simProvider === void 0 ? void 0 : simProvider.value) || ''),
    simProviderDropdownValue = _useState3[0],
    setSimProviderDropdownValue = _useState3[1];
  var _useState4 = useState(isExpanded),
    isExpandedState = _useState4[0],
    setIsExpandedState = _useState4[1];
  var _useState5 = useState(_state),
    stateType = _useState5[0],
    setStateType = _useState5[1];
  var _useState6 = useState((_a = _stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading) !== null && _a !== void 0 ? _a : ''),
    subHeading = _useState6[0],
    setSubHeading = _useState6[1];
  var isDisabledState = stateType === 'disabled';
  var isSuccessState = stateType === 'success';
  var skycFormWidgetStyle = getSkycFormWidgetStyles(props);
  var simPortDetailsStyle = getSimPortDetailsStyles();
  useEffect(() => {
    setSubHeading(_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading);
  }, [_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading]);
  useEffect(() => {
    var _ref = _inputData || {},
      mobileNumber = _ref.mobileNumber;
    setMobileNumberInputProps(prev => {
      var updatedMobileInputProps = Object.assign(Object.assign({}, prev), mobileNumber);
      handleValidation({
        mobileNumber: updatedMobileInputProps,
        upcCode: upcCodeInputProps,
        simProvider: simProviderDropdownValue
      });
      return updatedMobileInputProps;
    });
  }, [JSON.stringify(_inputData === null || _inputData === void 0 ? void 0 : _inputData.mobileNumber)]);
  useEffect(() => {
    var _ref2 = _inputData || {},
      upcCode = _ref2.upcCode;
    setUpcCodeInputProps(prev => {
      var updatedUpcInputProps = Object.assign(Object.assign({}, prev), upcCode);
      handleValidation({
        mobileNumber: mobileNumberInputProps,
        upcCode: updatedUpcInputProps,
        simProvider: simProviderDropdownValue
      });
      return updatedUpcInputProps;
    });
  }, [JSON.stringify(_inputData === null || _inputData === void 0 ? void 0 : _inputData.upcCode)]);
  useEffect(() => {
    setStateType(_state);
    setIsExpandedState(_state === 'none');
  }, [_state]);
  useEffect(() => {
    setIsExpandedState(isExpanded);
    if (!isExpanded) Keyboard.dismiss();
  }, [isExpanded]);
  var handleDropdownChange = data => {
    var _a;
    var value = (_a = data === null || data === void 0 ? void 0 : data[2]) === null || _a === void 0 ? void 0 : _a.subHeading;
    setStateType('none');
    setSubHeading('');
    var updatedSimProvider = {
      simDropdownValue: value,
      state: 'none'
    };
    setSimProviderDropdownValue(value);
    var formData = {
      mobileNumber: mobileNumberInputProps,
      upcCode: upcCodeInputProps,
      simProvider: value
    };
    handleValidation(formData);
    if (simProvider === null || simProvider === void 0 ? void 0 : simProvider.onChangeMetaData) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, simProvider === null || simProvider === void 0 ? void 0 : simProvider.onChangeMetaData), Object.assign({}, updatedSimProvider));
    }
  };
  var handleOnValidInputMetaData = (value, inputType) => {
    if (inputType === 'mobile') {
      (mobileNumberInputProps === null || mobileNumberInputProps === void 0 ? void 0 : mobileNumberInputProps.onValidInputMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, mobileNumberInputProps === null || mobileNumberInputProps === void 0 ? void 0 : mobileNumberInputProps.onValidInputMetaData), Object.assign(Object.assign({}, mobileNumberInputProps), {
        value
      })));
    } else {
      (upcCodeInputProps === null || upcCodeInputProps === void 0 ? void 0 : upcCodeInputProps.onValidInputMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, upcCodeInputProps === null || upcCodeInputProps === void 0 ? void 0 : upcCodeInputProps.onValidInputMetaData), Object.assign(Object.assign({}, upcCodeInputProps), {
        value
      })));
    }
  };
  var handleOnInValidInputMetaData = (value, inputType) => {
    if (inputType === 'mobile') {
      (mobileNumberInputProps === null || mobileNumberInputProps === void 0 ? void 0 : mobileNumberInputProps.onInValidInputMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, mobileNumberInputProps === null || mobileNumberInputProps === void 0 ? void 0 : mobileNumberInputProps.onInValidInputMetaData), Object.assign(Object.assign({}, mobileNumberInputProps), {
        value
      })));
    } else {
      (upcCodeInputProps === null || upcCodeInputProps === void 0 ? void 0 : upcCodeInputProps.onInValidInputMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, upcCodeInputProps === null || upcCodeInputProps === void 0 ? void 0 : upcCodeInputProps.onInValidInputMetaData), Object.assign(Object.assign({}, upcCodeInputProps), {
        value
      })));
    }
  };
  var handleOnPressIn = inputType => {
    if (inputType === 'mobile') {
      (mobileNumberInputProps === null || mobileNumberInputProps === void 0 ? void 0 : mobileNumberInputProps.onClickMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, mobileNumberInputProps === null || mobileNumberInputProps === void 0 ? void 0 : mobileNumberInputProps.onClickMetaData), Object.assign({}, mobileNumberInputProps)));
    } else {
      (upcCodeInputProps === null || upcCodeInputProps === void 0 ? void 0 : upcCodeInputProps.onClickMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, upcCodeInputProps === null || upcCodeInputProps === void 0 ? void 0 : upcCodeInputProps.onClickMetaData), Object.assign({}, upcCodeInputProps)));
    }
  };
  var useDebouncedFunction = (callback, delay) => {
    return useCallback(debounce(callback, delay), [callback, delay]);
  };
  var functionDebounce = useDebouncedFunction((metaData, formData) => {
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, metaData), Object.assign({
      props
    }, formData));
  }, autoFormSubmitDebounceDelay);
  var handleValidation = formData => {
    var mobileNumber = formData.mobileNumber,
      upcCode = formData.upcCode,
      simProvider = formData.simProvider;
    var isValid = validateInputField(mobileNumber) && validateInputField(upcCode);
    isValid = isValid && (simProvider === null || simProvider === void 0 ? void 0 : simProvider.length) > 0;
    var metaData = isValid ? onValidFormMetaData : onInValidFormMetaData;
    var handleUserAction = metaData => {
      if (isValidObject(metaData)) {
        if (isAutoFormSubmitDebounceAllowed) {
          functionDebounce(metaData, formData);
        } else {
          onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, metaData), Object.assign({
            props
          }, formData));
        }
      }
    };
    handleUserAction(metaData);
    return isValid;
  };
  var handleChangeButtonPress = () => {
    setIsExpandedState(true);
  };
  var handleInputChange = (value, type) => {
    setStateType('none');
    setSubHeading('');
    if (type === 'mobile') {
      var updatedMobileProps = Object.assign(Object.assign({}, mobileNumberInputProps), {
        value,
        state: 'none',
        showLoader: false
      });
      setMobileNumberInputProps(updatedMobileProps);
      var formData = {
        mobileNumber: updatedMobileProps,
        upcCode: upcCodeInputProps,
        simProvider: simProviderDropdownValue
      };
      handleValidation(formData);
      (mobileNumberInputProps === null || mobileNumberInputProps === void 0 ? void 0 : mobileNumberInputProps.onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, mobileNumberInputProps === null || mobileNumberInputProps === void 0 ? void 0 : mobileNumberInputProps.onChangeMetaData), Object.assign({}, updatedMobileProps)));
    } else {
      var updatedupcCodeProps = Object.assign(Object.assign({}, upcCodeInputProps), {
        value,
        state: 'none',
        showLoader: false
      });
      setUpcCodeInputProps(updatedupcCodeProps);
      var _formData = {
        mobileNumber: mobileNumberInputProps,
        upcCode: updatedupcCodeProps,
        simProvider: simProviderDropdownValue
      };
      handleValidation(_formData);
      (upcCodeInputProps === null || upcCodeInputProps === void 0 ? void 0 : upcCodeInputProps.onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, upcCodeInputProps === null || upcCodeInputProps === void 0 ? void 0 : upcCodeInputProps.onChangeMetaData), Object.assign({}, updatedupcCodeProps)));
    }
  };
  return isValidObject(_stepDetails) && _jsx(Collapsible, Object.assign({
    theme: theme,
    withCard: true,
    childPaddingToken: "SPACING_0",
    titlePaddingToken: "SPACING_0",
    showIcon: false,
    removeOverflow: true
  }, getTestId(testID, variant + "_Collapsible"), {
    isExpanded: isExpandedState,
    disabled: getIsDisabledState(isDisabledState, disableToggle),
    style: [skycFormWidgetStyle.heading, style],
    titleNoVerticalPadding: true,
    titleNoHorizontalPadding: true,
    titleComponent: _jsx(LinkListItemWidget, Object.assign({}, _stepDetails, isSuccessState && !isExpandedState && successStateHeading && {
      heading: successStateHeading
    }, {
      roundedCorners: true,
      theme: theme,
      noHoverEffect: true,
      noPressEffect: true,
      onPress: onStepDetailsListItemPressMetaData
    }, getTestId(testID, variant + "_LinkListItemWidget"), {
      onUserAction: onUserAction,
      actionTypeProps: !isExpandedState && !isDisabledState && (_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.actionTypeProps),
      actionTypeOnPressMetaData: onStepDetailsCtaPressMetaData,
      actionTypeOnPress: handleChangeButtonPress
    }, isSuccessState && Object.assign({}, successAvatarConfig), isSuccessState && !isExpandedState && {
      subHeading: getSubHeading(mobileNumberInputProps === null || mobileNumberInputProps === void 0 ? void 0 : mobileNumberInputProps.value, simProviderDropdownValue, upcCodeInputProps === null || upcCodeInputProps === void 0 ? void 0 : upcCodeInputProps.value, subHeading)
    }, {
      disabled: getIsDisabledState(isDisabledState, _stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.disabled),
      subHeadingNumberOfLines: (_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeadingNumberOfLines) || 1
    }))
  }, {
    children: _jsxs(View, Object.assign({
      style: [skycFormWidgetStyle.content]
    }, {
      children: [_jsx(Input, Object.assign({
        containerStyle: simPortDetailsStyle.input
      }, mobileNumberInputProps, {
        theme: theme
      }, getTestId(testID, variant + "_mobileNumberInput"), {
        readOnlyOnPress: () => handleOnPressIn('mobile'),
        onValidInput: value => handleOnValidInputMetaData(value, 'mobile'),
        onInValidInput: value => handleOnInValidInputMetaData(value, 'mobile'),
        onChangeText: value => handleInputChange(value, 'mobile')
      })), _jsx(Input, Object.assign({
        containerStyle: simPortDetailsStyle.input
      }, upcCodeInputProps, {
        theme: theme
      }, getTestId(testID, variant + "_upcCodeInput"), {
        readOnlyOnPress: () => handleOnPressIn('upcCode'),
        onValidInput: value => handleOnValidInputMetaData(value, 'upcCode'),
        onInValidInput: value => handleOnInValidInputMetaData(value, 'upcCode'),
        onChangeText: value => handleInputChange(value, 'upcCode')
      })), _jsx(Dropdown, Object.assign({}, simProvider, getTestId(testID, variant + "_simPortDropdown"), {
        theme: theme,
        position: "below",
        listMaxHeightPercentage: 30,
        postfixIconName: "DownChevronIcon",
        onSelectedHandler: function onSelectedHandler() {
          for (var _len = arguments.length, value = new Array(_len), _key = 0; _key < _len; _key++) {
            value[_key] = arguments[_key];
          }
          return handleDropdownChange(value);
        },
        style: simPortDetailsStyle.dropdown
      }))]
    }))
  }));
};